import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import AreaN1DataService from "./services/arean1.service";
import Sidebar from './Sidebar';
import ExportSidebar from './ProSideBar';
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class NewAreaN1 extends Component {  

  constructor(props) {
    super(props);
    this.onChangeAreaN1 = this.onChangeAreaN1.bind(this);
    this.onChangeAreaN1Description = this.onChangeAreaN1Description.bind(this);
    this.saveAreaN1 = this.saveAreaN1.bind(this);
    //this.retrieveAreasN1 = this.retrieveAreasN1.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.goToAreasList = this.goToAreasList.bind(this);

    this.state = {
      id: null,
      nombrearea: "",
      descripcionarea: "",
      submitted: false,
      areas: [],
      currentarea: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  goToAreasList() {
    window.location.assign('/areas');
  }

  handleValidations() {
    if (this.state.nombrearea.length==0) {
      this.setState({errmessage:'Fields can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    this.saveAreaN1();
  } 
  /*
  retrieveAreasN1() {
    AreaN1DataService.getAll()
      .then(response => {
        this.setState({
            areas: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }
  */

  refreshList() {
    // is this actually needed?
    //this.retrieveAreasN1();
    this.setState({
        currentarea: null,
        currentIndex: -1
    });
  }

  onChangeAreaN1(e) {
    this.setState({
      nombrearea: e.target.value
    });
  }

  onChangeAreaN1Description(e) {
    this.setState({
      descripcionarea: e.target.value
    });
  } 

  saveAreaN1() {
    var data = {
      nombrearea: this.state.nombrearea,
      descripcionarea: this.state.descripcionarea        
    };

    AreaN1DataService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          nombrearea: response.data.nombrearea,
          descripcionarea: response.data.descripcionarea,
          submitted: true          // 
        });
        this.setState({showerror:false});
        this.setState({errmessage:''});
        
        this.setState({succmessage:'El área N1 ha sido creada. Redirigiendo a la lista de áreas...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data);
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  render() {
    return (
      <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />       
        <Container>
          <Row className='mb-2'>
            <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Fecha actual: {gtDate}</FormLabel>
            <hr/>
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Nueva área N1</h5>
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre área N1:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombrearean1" id="nombrearean1" onChange={this.onChangeAreaN1}></FormControl>
            </Col>

            <Col md={8}>
              <FormLabel className='mb-2'>Descripción:</FormLabel>       
              <FormControl type="text" name="descripcionarean1" id="descripcionarean1" onChange={this.onChangeAreaN1Description}></FormControl>
            </Col>          

          </Row>
          <hr/>
          <Row className='mb-2'>
            <Col className='col-md-4'>
              <Button id='saveItem' className='btn-secondary' onClick={this.handleValidations}>Guardar área N1</Button>            
              <Button className='m-2 btn-secondary' id='backToAreasList' onClick={this.goToAreasList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>  
          {this.state.showerror && (
            <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{this.state.errmessage}</p>
            </Alert>      
          )}
          {this.state.showsuccess && (
            <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{this.state.succmessage}</p>
            </Alert>      
          )}     
          { this.state.submitted ? (<Navigate push to="/areas"/>) : null }                                     
        </Container>
      </div>
      </>
    )      
  }
}

export default NewAreaN1;